module.exports = __webpack_public_path__ + "static/media/8OLA14.51f8d228.jpg";